import type { TranslationDict } from '../en';

const zh: TranslationDict = {
  'header.buy': '购买',
  'header.sell': '出售',
  'spend.label': '您支付',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': '您获得',
  'payment.label': '支付方式',
  'payment.select': '选择',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': '此交易对暂无可用支付方式',
  'wallet.label': '接收钱包地址',
  'wallet.placeholderBuy': '输入您的接收地址',
  'wallet.placeholderSell': '输入您的发送地址',
  'wallet.validating': '正在验证地址...',
  'wallet.invalid': '请输入有效的钱包地址',
  'wallet.invalidServer': '无效的钱包地址',
  'cta.buy': '购买 {crypto}',
  'cta.sell': '出售 {crypto}',
  'cta.gettingPrice': '正在获取最优价格...',
  'cta.processing': '处理中...',
  'footer.poweredBy': '技术支持 ',
  'footer.brand': 'NowRamp',
  'rate.title': '费率明细',
  'rate.close': '关闭',
  'rate.updatesIn': '费率将在 00:{seconds} 后更新',
  'rate.noQuote': '暂无可用报价',
  'rate.exchangeRate': '汇率',
  'rate.processingFee': '手续费',
  'rate.networkFee': '网络费',
  'rate.provider': '服务商',
  'toast.orderCreated': '订单已创建',
  'toast.redirecting': '正在跳转至结账页面...',
  'toast.orderFailed': '订单失败',
  'toast.couldNotCreate': '无法创建订单',
  'toast.quoteError': '报价错误',
  'toast.noProviders': '无可用服务商',
  'toast.somethingWrong': '出了点问题',
  'error.amountZero': '金额必须大于 0',
  'error.minAmountFiat': '最低金额为 {min} {currency}',
  'error.minAmountCrypto': '最低金额为 {min} {currency}',
  'error.noProviders': '此组合暂无可用服务商',
  'error.currencyUnavailableBuy': '该货币不支持购买订单',
  'error.currencyUnavailableSell': '该货币不支持出售订单',
  'parity.info': '您将被收取 {receiveAmount} {crypto}，剩余部分（最多 {spendAmount} {fiat}）将记入您的 {partner} 账户',
  'redirect.secureBadge': '安全支付',
  'redirect.title': '继续支付',
  'redirect.description': '您将被重定向至 {gateway} 以完成支付。',
  'redirect.countdown': '将在 {seconds} 后跳转...',
  'redirect.openTab': '在新标签页中打开 ACH',
  'redirect.cancel': '取消',
  'checkout.noOrder': '未找到订单',
  'checkout.goBack': '返回',
  'checkout.expired': '结账已过期',
  'checkout.expiredDesc': '会话已过期，请重试。',
  'checkout.startOver': '重新开始',
  'checkout.cancel': '取消',
  'checkout.loading': '正在加载结账页面...',
  'checkout.iframeTitle': '服务商结账',
  'checkout.widgetTitle': '支付结账',
  'checkout.unknownMethod': '未知的结账方式',
  'processing.default': '正在处理您的订单...',
  'processing.pending': '等待支付确认...',
  'processing.active': '正在处理您的交易...',
  'processing.generic': '处理中...',
  'processing.checkingStatus': '正在检查状态...',
  'processing.orderId': '订单 ID',
  'processing.provider': '服务商',
  'processing.amount': '金额',
  'processing.receiving': '接收',
  'processing.network': '网络',
  'processing.toAddress': '目标地址',
  'processing.usuallyMinutes': '通常需要几分钟时间。',
  'processing.safeToClose': '您可以安全关闭此页面，完成后我们会通过邮件通知您。',
  'complete.buyTitle': '购买完成！',
  'complete.sellTitle': '出售完成！',
  'complete.buyDesc': '您的 {crypto} 已发送至您的钱包。',
  'complete.sellDesc': '您的 {fiat} 付款正在处理中。',
  'complete.amountBuy': '接收金额',
  'complete.amountSell': '出售金额',
  'complete.paidBuy': '支付金额',
  'complete.paidSell': '到账金额',
  'complete.network': '网络',
  'complete.wallet': '钱包',
  'complete.transaction': '交易',
  'complete.provider': '服务商',
  'complete.orderId': '订单 ID',
  'complete.completed': '已完成',
  'complete.viewExplorer': '在浏览器中查看',
  'complete.done': '完成',
  'errorStep.failed': '支付失败',
  'errorStep.cancelled': '订单已取消',
  'errorStep.expired': '订单已过期',
  'errorStep.refunded': '订单已退款',
  'errorStep.unknown': '出了点问题',
  'errorStep.failedBuy': '您的支付无法处理。请重试或使用其他支付方式。',
  'errorStep.failedSell': '您的出售无法处理。请重试。',
  'errorStep.cancelledBuy': '您的订单已取消。未处理任何付款。',
  'errorStep.cancelledSell': '您的出售已取消。未转移任何加密货币。',
  'errorStep.expiredBuy': '您的订单已过期。请重新购买。',
  'errorStep.expiredSell': '您的订单已过期。请重新出售。',
  'errorStep.refundedBuy': '您的付款已退还。资金将在 5-10 个工作日内到账。',
  'errorStep.refundedSell': '您的加密货币已退还。资金将很快出现在您的钱包中。',
  'errorStep.genericDesc': '发生意外错误。请重试。',
  'errorStep.orderId': '订单 ID',
  'errorStep.tryAgain': '重试',
  'errorStep.startOver': '重新开始',
  'errorStep.return': '返回',
  'errorStep.needHelp': '需要帮助？请联系 ',
  'errorStep.reference': '参考编号：{orderId}',
  'confirm.buyTitle': '确认购买',
  'confirm.sellTitle': '确认出售',
  'confirm.loading': '加载中...',
  'confirm.provider': '服务商',
  'confirm.youPay': '您支付',
  'confirm.youSell': '您出售',
  'confirm.youReceive': '您获得',
  'confirm.wallet': '钱包',
  'confirm.network': '网络',
  'confirm.refundAddress': '退款地址',
  'confirm.parityNote': '服务商实际收取金额可能有所不同。剩余部分（最多 {amount} {crypto}）将记入您的 {partner} 账户。',
  'confirm.processing': '处理中...',
  'confirm.confirmPay': '确认并支付',
  'confirm.confirmSell': '确认并出售',
  'confirm.payout': '{currency} 付款',
  'modal.selectFiat': '选择法定货币',
  'modal.selectCrypto': '选择加密货币',
  'modal.choosePayment': '选择支付方式',
  'modal.selectCountry': '选择您的国家/地区',
  'modal.selectLanguage': 'Select language',
  'modal.popular': '热门',
  'modal.recommended': '推荐',
  'modal.noCurrencies': '未找到货币',
  'modal.noPaymentMethods': '未找到支付方式',
  'modal.noCountries': '未找到国家/地区',
  'modal.noLanguages': 'No languages found',
  'settings.location': '位置',
  'settings.darkMode': '深色模式',
  'settings.privacy': '隐私政策',
  'settings.terms': '使用条款',
  'settings.language': '语言',
  // ─── Additional ───
  'modal.chooseRamp': '选择 Ramp',
  'modal.bestPrice': '最优价格',
  'modal.noQuotes': '此请求暂无可用报价',
  'modal.noProvidersFound': '未找到服务商',
  'payment.unavailableFor': '{currency} 暂无可用支付方式',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': '创建订单失败',
  'errorStep.returnToMerchant': '返回商家',
  'confirm.cryptoOnNetwork': '{crypto} 在 {network} 网络',
  'payment.name.card': '卡',
  'payment.name.bankTransfer': '银行转账',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default zh;
